import { useEffect, useState } from 'react';
import { SchoolClassesConfig } from '../../../types/schoolConfigType';
import { academicYears } from '../../../constants/academicYears';

export const useAcademicTermsSearch = (allClasses?: SchoolClassesConfig) => {
  const defaultAcademicYear = academicYears.find((year) => year.isDefault);
  const [academicYear, setAcademicYear] = useState(
    defaultAcademicYear?.value || ''
  );
  const [selectedGrade, setSelectedGrade] = useState('');
  const [selectedDivision, setSelectedDivision] = useState('');
  const [divisionOptions, setDivisionOptions] = useState<string[]>([]);

  useEffect(() => {
    if (!allClasses) return;

    const divisions =
      selectedGrade && allClasses.classes
        ? allClasses.classes
            .filter(({ grade }) => grade === selectedGrade)
            .map(({ division }) => division)
        : allClasses.divisions || [];

    setDivisionOptions(divisions);
  }, [allClasses, selectedGrade]);

  const gradeOption =
    allClasses?.grades?.map((g) => ({ value: g, label: g })) ?? [];

  const divisionOption = divisionOptions.map((d) => ({ value: d, label: d }));

  return {
    academicYear,
    selectedGrade,
    selectedDivision,
    gradeOption,
    divisionOption,
    divisionOptions,
    setAcademicYear,
    setSelectedGrade,
    setSelectedDivision,
    setDivisionOptions
  };
};
